<template>
    <section class="netto-product-bidding">
        <header class="netto-product-bidding__header">{{ $t('ProductSelect.bidding.wishPrice') }}</header>

        <p class="mb-0">
            {{ $t('ProductSelect.bidding.wishText') }}
        </p>

        <div class="netto-product-bidding__total">
            <span>{{ $t('ProductSelect.bidding.totalValue') }}</span>

            <Price
                v-if="listPrice"
                :minimum-price="listPrice"
                class="netto-product-bidding__total-value"
                :show-prefix="false"
                ignore-price-mode
            />
        </div>

        <BidInputWithButtons v-model="bidAmount" />

        <BiddingCheckoutLink
            :product-variant-id="selectedVariant.id"
            :bid-amount="bidAmount"
            :disabled="!bidAmount"
            class="netto-product-bidding__submit netto-block__offer-button text-decoration-none"
        >
            <span class="align-middle">{{ $t('ProductSelect.bidding.placeBid') }}</span>
        </BiddingCheckoutLink>
    </section>
</template>

<script>
import Price from '@/components/Price.vue';
import BidInputWithButtons from '@/components/product/auction/BidInputWithButtons.vue';
import BiddingCheckoutLink from '@/components/product/auction/BiddingCheckoutLink.vue';

export default {
    name: 'NettoProductSelectBidding',

    components: { BiddingCheckoutLink, BidInputWithButtons, Price },

    data() {
        return {
            bidAmount: null // TODO: mixin?
        };
    },

    props: {
        selectedVariant: {
            type: Object,
            required: true
        }
    },

    computed: {
        listPrice() {
            return this.$getSafe(this.selectedVariant, 'price.regularPriceValues.listPrice');
        }
    }
};
</script>

<style scoped lang="scss">
.netto-product-bidding {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    &__header {
        text-align: center;
        color: var(--primary);
        font-size: 1.125rem;
        font-weight: 500;
    }

    &__total {
        display: flex;
        flex-wrap: nowrap;
        font-weight: 500;
        font-size: 1.125rem;
        justify-content: space-between;
        align-items: baseline;
    }

    &__total-value {
        margin-left: auto;
        font-size: 1.5rem;
        font-weight: 700;
    }

    &__submit {
        text-decoration: none !important;
        font-size: 1.125rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
